"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Separator } from "@/components/ui/separator";
export default function Philosophy() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: essayRef,
    isVisible: essayVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const values = ["Bienveillance", "Sérénité", "Écoute"];
  return <section data-section-id="48" id="un-accompagnement-pensé-pour-les-premières-semaines-avec-bébé" className="bg-background text-foreground py-14 px-6 md:py-16 lg:py-20 md:px-10 lg:px-16" style={{
    backgroundColor: "var(--background)"
  }}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8 lg:gap-12">
          {}
          <div ref={headerRef} className={`lg:col-span-5 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <div className="lg:sticky lg:top-24">
              <p className="font-sans text-xs md:text-sm tracking-[0.2em] uppercase mb-6" style={{
              color: "var(--primary)"
            }}>
                — MON APPROCHE
              </p>
              <h2 className="font-serif font-light leading-[1.05] mb-8 tracking-tight" style={{
              fontSize: "clamp(1.75rem, 4vw, 3.5rem)"
            }}>
                <span className="!text-5xl">
                  Je prends soin de toi, pendant que tu prends soin de ton bébé.
                </span>
              </h2>
              <p className="font-sans text-xs tracking-[0.15em] uppercase" style={{
              color: "var(--primary)"
            }}>
                <br />
              </p>
            </div>
          </div>

          {}
          <div ref={essayRef} className={`lg:col-span-7 transition-all duration-1000 ease-out delay-150 ${essayVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <article className="font-default text-lg md:text-[19px] leading-[1.7]" style={{
            color: "var(--brun)"
          }} data-ast-id="f:/src/pages/Home/sections/Philosophy.tsx|sig:m7yrnf" data-ast-start="2234" data-ast-end="3709">
              <p className="mb-8" data-ast-id="f:/src/pages/Home/sections/Philosophy.tsx|sig:xg758v" data-ast-start="2689" data-ast-end="3047" contentEditable="false" style={{}}>
                Le post-partum est une période de transformation profonde – physique, émotionnelle et identitaire. SLOW MAMA propose un accompagnement postnatal bienveillant et centré sur le respect du lien mère-bébé.
              </p>
              <p className="mb-0" data-ast-id="f:/src/pages/Home/sections/Philosophy.tsx|sig:xg758x" data-ast-start="3335" data-ast-end="3686" contentEditable="false" style={{}}>
                Chaque accompagnement est personnalisé: repas, soutien émotionnel, aide légère à la maison, soins corporels, présence auprès du bébé pendant que vous vous reposez.
              </p>
            </article>
          </div>
        </div>

        {}
        <div ref={imageRef} className={`mt-8 md:mt-12 lg:mt-16 lg:ml-[25%] transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          
        </div>

        {}
        <div ref={footerRef} className={`mt-8 md:mt-12 transition-all duration-1000 ease-out ${footerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}></div>
      </div>
    </section>;
}